'use strict'

import 'whatwg-fetch'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/messaging'

import redirect from './lib/redirect.js'
import fbmessaging from './lib/fbmessaging.js'
import headerIcon from './lib/headerIcon.js'

const config = require('AppConfig')

// Initialize Firebase
firebase.initializeApp(config.firebase)
firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .then(() => {
        fbmessaging.initializeMessaging()
        firebase.analytics()
    })
    
headerIcon.startUI()

redirect.watch()

/**
 * ペイウォールからのアクセスの場合、ログイン後そのページへ復帰するために
 * ローカルストレージへ参照元の一記事URLを格納する
 */
document.querySelectorAll('#paywall_signup, #paywall_login').forEach(btn => {
    btn.addEventListener(
        'click',
        event => {
            let url = location.href
            let allowedDomain = config.allowedAccessFromPaywallDomain
            if (url.match(allowedDomain)) {
                localStorage.setItem('paywall', url)
            }
        },
        false
    )
})
